export function StatLoading() {
  return (
    <div className="min-h-screen bg-base-200 flex items-center justify-center">
      <div className="loading loading-spinner loading-lg" />
    </div>
  );
}

export function StatError({ message }: { message: string }) {
  return <div className="min-h-screen bg-base-200 flex items-center justify-center text-error">{message}</div>;
}

export function StatEmpty({ message }: { message: string }) {
  return <div className="min-h-screen bg-base-200 flex items-center justify-center opacity-70">{message}</div>;
}
